import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';

import { Box, Button, ButtonBase, Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { Title } from './style';

import { useDegreeLandingPageData } from '@helpers/use';
import { numberWithCommas, sanitize } from '@helpers/utils';

export const AboutSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [isExpand, setIsExpand] = useState<boolean>(false);

  const router = useRouter();

  const universityId = router.query.universityIdName as string;
  const degreeId = router.query.degreeIdName as string;

  const { landingPage } = useDegreeLandingPageData(universityId, degreeId);

  const onExpandToggle = () => {
    setIsExpand((s) => !s);
  };

  return (
    <Grid container spacing={3} mb={3}>
      <Grid item lg={8} xs={12}>
        <Title>{t('degree_landing_page.about_section.title')}</Title>
        <Typography variant="body2_deprecated">
          <Box
            sx={{
              whiteSpace: 'pre-wrap',
              ...(!isExpand
                ? {
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  overflow: 'hidden',
                  WebkitLineClamp: 6,
                  WebkitBoxOrient: 'vertical',
                }
                : {}),
            }}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={sanitize(
              isExpand
                ? `${landingPage?.aboutDegree}\n${landingPage?.degreeDetail}` || ''
                : `${landingPage?.aboutDegree}`,
            )}
          />
        </Typography>
        {landingPage?.degreeDetail && (
          <ButtonBase sx={{ ...theme.typography.button }} onClick={onExpandToggle} disableRipple>
            {t(
              isExpand
                ? 'degree_landing_page.about_section.button.show_less'
                : 'degree_landing_page.about_section.button.show_more',
            )}
          </ButtonBase>
        )}
      </Grid>
      <Grid item lg={4} xs={12}>
        <Title>{t('degree_landing_page.overall.title')}</Title>
        <Grid container spacing={3}>
          <Grid item container alignItems="center" spacing={3} xs={12} md={6} lg={12}>
            <Grid item>
              <Image src="/static/icons/slideshow.svg" height={80} width={80} />
            </Grid>
            <Grid item>
              <Typography fontSize={24} lineHeight={1}>
                {t('degree_landing_page.about_section.minimum_degree_course.title')}
              </Typography>
              <Typography
                fontSize={36}
                lineHeight="43px"
                fontWeight={{
                  xs: 700,
                  md: 400,
                }}
              >
                {t('degree_landing_page.about_section.minimum_degree_course.count', {
                  count: landingPage?.minimumDegreeCourses,
                })}
              </Typography>
            </Grid>
          </Grid>
          <Grid item container alignItems="center" spacing={3} xs={12} md={6} lg={12}>
            <Grid item>
              <Image src="/static/icons/label.svg" height={80} width={80} />
            </Grid>
            <Grid item>
              <Typography fontSize={24} lineHeight={1}>
                {t('degree_landing_page.about_section.starting_course_price.title')}
              </Typography>
              <Typography
                fontSize={36}
                lineHeight="43px"
                fontWeight={{
                  xs: 700,
                  md: 400,
                }}
              >
                {t('degree_landing_page.about_section.starting_course_price.value', {
                  value: landingPage?.degreeMinimumCoursePrice
                    ? numberWithCommas(landingPage?.degreeMinimumCoursePrice)
                    : '',
                })}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
